import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const navLinks = [
  { label: "How It Works", id: "how-it-works" },
  { label: "For Patients", id: "for-whom" },
  { label: "For Clinics", id: "for-whom" },
  { label: "Reports", id: "analysis" },
];

const LandingNav = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#060C18]/95 backdrop-blur-xl border-b border-white/10 shadow-2xl"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-3 focus:outline-none"
        >
          <img
            src="/assets/images/graftcounter-logo.png"
            alt="Graft Counter"
            className="h-8 w-8 object-contain rounded-lg"
          />
          <span className="text-white font-semibold text-base tracking-tight">
            Graft Counter
          </span>
        </button>

        {/* Desktop nav links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.id)}
              className="text-white/55 hover:text-white/90 text-sm font-medium transition-colors duration-200"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => navigate("/login-screen")}
            className="text-white/60 hover:text-white text-sm font-medium transition-colors px-4 py-2"
          >
            Sign In
          </button>
          <button
            onClick={() => navigate("/gc-about")}
            className="group flex items-center gap-1.5 px-5 py-2 bg-royal-600 hover:bg-royal-500 text-white rounded-lg text-sm font-medium transition-all duration-200"
          >
            Get Started
            <ArrowRight size={13} className="group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white/80 hover:text-white p-2 -mr-2 transition-colors"
          onClick={() => setMobileOpen((p) => !p)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-[#060C18] border-t border-white/10 px-6 pt-5 pb-6 space-y-1">
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.id)}
              className="block w-full text-left text-white/65 hover:text-white text-base py-2.5 font-medium transition-colors"
            >
              {item.label}
            </button>
          ))}
          <div className="pt-4 flex flex-col gap-3 border-t border-white/10 mt-3">
            <button
              onClick={() => { setMobileOpen(false); navigate("/login-screen"); }}
              className="w-full py-3 border border-white/15 text-white rounded-xl text-sm font-medium transition-all hover:border-white/30"
            >
              Sign In
            </button>
            <button
              onClick={() => { setMobileOpen(false); navigate("/gc-about"); }}
              className="w-full py-3 bg-royal-600 hover:bg-royal-500 text-white rounded-xl text-sm font-medium transition-all"
            >
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
